import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "circle" }
const _hoisted_2 = { class: "step-content" }
const _hoisted_3 = { class: "alert" }
const _hoisted_4 = { class: "caption" }

import { computed, PropType, ref } from "vue";
import { TimelineMilestone, TimelineMilestoneStatus } from "@/models/applicationStatus";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineStep',
  props: {
  status: {
    type: String,
    default: "",
  },
  step: {
    type: Number,
    default: 1,
  },
  title: {
    type: String,
    default: "",
  },
  configuration: {
    type: Object as PropType<TimelineMilestone>,
  },
  maximumStep: {
    type: Number,
    default: 1,
  },
},
  emits: ["titleClicked"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const showCompletedIndicatorText = ref<boolean>(false);
const complete = computed<boolean>(() => props.status === "complete");
const isActive = computed<boolean>(() => props.configuration?.isActive || false);
const isComplete = computed<boolean>(
  () => props.configuration?.status === TimelineMilestoneStatus.COMPLETE,
);
const isLastItem = computed<boolean>(() => props.step >= props.maximumStep);
const isClickable = computed<boolean>(
  () => (props.configuration?.title && (isActive.value || isComplete.value)) || false,
);

const stepContent = computed(() => {
  if (props.status === "declined") {
    return "!";
  }

  return complete.value ? "✓" : props.step;
});

function handleTitleClick() {
  // only emit if there is a title to click on and status is not inactive
  if (props.configuration?.title && (isActive.value || isComplete.value)) {
    emit("titleClicked", props.configuration.step);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["step", [__props.status, { isActive: isActive.value, isComplete: isComplete.value, isLastItem: isLastItem.value }]])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(stepContent.value), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "circle-tail status-item-tail" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["title", [{ clickable: isClickable.value, isActive: isActive.value }, __props.status]]),
        onClick: handleTitleClick
      }, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _createTextVNode(_toDisplayString(__props.title) + " " + _toDisplayString(showCompletedIndicatorText.value && isComplete.value ? " --> Completed!" : ""), 1)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "alert")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "caption")
      ])
    ])
  ], 2))
}
}

})